/**
 * teamUtils.ts
 * 
 * BUGFIX T4: Team Code Normalization
 * 
 * Problem: Events use "LA" but players use "LAR". This causes:
 * - Game filtering to fail (Rams players disappear)
 * - Defense rank lookup to miss (shows #16 fallback)
 * 
 * Solution: Centralized normalization map used everywhere team codes are compared.
 * 
 * Created: January 24, 2026
 * Reference: TUNNEL_UI_BUGFIX_DEV_PLAN v1.1
 */

/**
 * Team code normalization map.
 * Maps variant codes to canonical codes.
 * Add additional mappings as discovered.
 */
export const TEAM_NORMALIZE: Record<string, string> = {
  'LA': 'LAR',    // Rams - events use "LA", players use "LAR"
  // Add others as discovered, e.g.:
  // 'WSH': 'WAS',  // Example if Washington has variants
  // 'JAC': 'JAX',  // Example if Jacksonville has variants
};

/**
 * Normalizes a team code to its canonical form.
 * @param code - The team code to normalize (e.g., "LA", "lar", "LAR")
 * @returns Normalized uppercase team code (e.g., "LAR")
 */
export function normTeam(code?: string): string {
  if (!code) return '';
  const upper = code.toUpperCase();
  return TEAM_NORMALIZE[upper] || upper;
}
